/**
 * PCケースカスタマイザー → Globo Product Options 選択引き継ぎ
 *
 * Shopify管理画面:
 * 1. assets/globo-selection-bridge.js として保存
 * 2. layout/theme.liquid の </body> 直前に以下を追加
 *    <script src="{{ 'globo-selection-bridge.js' | asset_url }}" defer></script>
 */
(function () {
  const params = new URLSearchParams(window.location.search);
  const selections = [
    { group: 'フロントパネル', value: params.get('pcc_front') },
    { group: 'サイドパネル', value: params.get('pcc_side') }
  ].filter((item) => item.value);

  if (!selections.length) return;

  const normalize = (value) =>
    String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase();

  const emitChange = (element) => {
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const findOptionGroup = (root, groupName, requestedValue) => {
    const wantedGroup = normalize(groupName);
    const wantedValue = normalize(requestedValue);
    const candidates = Array.from(root.querySelectorAll(
      'fieldset, .gpo-element, [class*="gpo-element"], [data-gpo-element], [class*="gpo-"], div'
    )).filter((element) => {
      const text = normalize(element.textContent);
      const hasControls = element.querySelector(
        'input[type="radio"], input[type="checkbox"], select, [role="radio"], [role="option"]'
      );
      return hasControls && text.includes(wantedGroup) && text.includes(wantedValue);
    });

    candidates.sort((a, b) => a.textContent.length - b.textContent.length);
    return candidates[0] || null;
  };

  const selectValue = (root, requestedValue) => {
    const wanted = normalize(requestedValue);
    let selected = false;

    root.querySelectorAll('select').forEach((select) => {
      const option = Array.from(select.options).find((item) =>
        normalize(item.value) === wanted || normalize(item.textContent) === wanted
      );

      if (!option || select.value === option.value) return;
      select.value = option.value;
      emitChange(select);
      selected = true;
    });

    root.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
      const label = input.id
        ? root.querySelector(`label[for="${CSS.escape(input.id)}"]`)
        : input.closest('label');
      const values = [
        input.value,
        input.dataset.value,
        input.getAttribute('data-label'),
        label?.textContent
      ];

      if (!values.some((value) => normalize(value) === wanted) || input.checked) return;
      input.click();
      emitChange(input);
      selected = true;
    });

    root.querySelectorAll('button, [role="radio"], [role="option"]').forEach((button) => {
      const values = [
        button.dataset.value,
        button.getAttribute('aria-label'),
        button.textContent
      ];

      if (!values.some((value) => normalize(value) === wanted)) return;
      if (button.getAttribute('aria-checked') === 'true' || button.classList.contains('active')) return;
      button.click();
      selected = true;
    });

    return selected;
  };

  let attempts = 0;
  const applySelections = () => {
    attempts += 1;
    const globoRoot =
      document.querySelector('.gpo-app, #gpo-app, [data-gpo-app], [class*="gpo-container"]');

    if (globoRoot) {
      selections.forEach((item) => {
        const optionGroup = findOptionGroup(globoRoot, item.group, item.value);
        if (optionGroup) selectValue(optionGroup, item.value);
      });
    }

    if (attempts < 40) window.setTimeout(applySelections, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySelections, { once: true });
  } else {
    applySelections();
  }
})();
